import { render } from "./UserInquiryCard.vue?vue&type=template&id=779f95ed&ts=true"
import script from "./UserInquiryCard.vue?vue&type=script&lang=ts"
export * from "./UserInquiryCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__